import { ChangeDetectionStrategy, Component, input, output, OutputEmitterRef } from '@angular/core';
import {MdbModalRef} from "mdb-angular-ui-kit/modal";
import {MdbButtonComponent} from "../mdb-button/mdb-button.component";
import {TranslateModule} from "@ngx-translate/core";


@Component({
  selector: 'app-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MdbButtonComponent, TranslateModule],
  templateUrl: './modal.component.html',
  standalone: true,
  styleUrl: './modal.component.scss',
})
export class ModalComponent {
  title = input.required<string>();
  subtitle = input<string>();
  submitText = input('SUBMIT');
  closeText = input('CLOSE');
  additionalButtonText = input<string | undefined>();
  loading = input(false);
  hideCloseIcon = input(false);
  hideButtons = input(false);

  additionalButtonColor = input<string>('secondary');
  additionalButtonOutlined = input<boolean>(false);
  additionalButtonLoading = input<boolean>(false);
  submitClicked = output();
  additionalButtonClicked = output<any>();

  constructor(public modalRef: MdbModalRef<ModalComponent>) {}
}
